export default function Schedule() {
  return (
    <section id="schedule" className="py-24 bg-gradient-to-b from-[#FAF8F5] to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3E2723] mb-4">
            Diseñado para Familias con Valores
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Un horario consistente que se adapta a la vida familiar mientras enseña compromiso y responsabilidad
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
            <div className="bg-gradient-to-r from-[#D2691E] to-[#B8571A] p-8 text-white">
              <div className="flex items-center gap-4 mb-2">
                <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center">
                  <i className="ri-calendar-line text-3xl"></i>
                </div>
                <h3 className="text-3xl font-bold">Horario de Clases</h3>
              </div>
            </div>

            <div className="p-8 md:p-12">
              <div className="grid md:grid-cols-3 gap-8 mb-12">
                <div className="text-center">
                  <div className="w-20 h-20 bg-[#FFF8E1] rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <i className="ri-calendar-check-line text-4xl text-[#D2691E]"></i>
                  </div>
                  <h4 className="font-bold text-xl text-gray-900 mb-2">Días</h4>
                  <p className="text-2xl font-semibold text-[#D2691E]">Martes y Jueves</p>
                </div>

                <div className="text-center">
                  <div className="w-20 h-20 bg-[#FFF8E1] rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <i className="ri-time-line text-4xl text-[#D2691E]"></i>
                  </div>
                  <h4 className="font-bold text-xl text-gray-900 mb-2">Horario</h4>
                  <p className="text-2xl font-semibold text-[#D2691E]">5:00 PM</p>
                </div>

                <div className="text-center">
                  <div className="w-20 h-20 bg-[#FFF8E1] rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <i className="ri-group-line text-4xl text-[#D2691E]"></i>
                  </div>
                  <h4 className="font-bold text-xl text-gray-900 mb-2">Edades</h4>
                  <p className="text-2xl font-semibold text-[#D2691E]">5-17 años</p>
                </div>
              </div>

              <div className="bg-gradient-to-br from-[#FFF8E1] to-[#FFECB3] rounded-2xl p-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#D2691E] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-information-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg text-gray-900 mb-3">Niveles Disponibles</h4>
                    <div className="grid md:grid-cols-3 gap-4">
                      <div className="bg-white rounded-xl p-4 shadow-sm">
                        <p className="font-semibold text-[#D2691E] mb-1">Principiante</p>
                        <p className="text-sm text-gray-600">Sin experiencia previa</p>
                      </div>
                      <div className="bg-white rounded-xl p-4 shadow-sm">
                        <p className="font-semibold text-[#D2691E] mb-1">Intermedio</p>
                        <p className="text-sm text-gray-600">Con conocimientos básicos</p>
                      </div>
                      <div className="bg-white rounded-xl p-4 shadow-sm">
                        <p className="font-semibold text-[#D2691E] mb-1">Avanzado</p>
                        <p className="text-sm text-gray-600">Perfeccionamiento técnico</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8 text-center">
                <p className="text-gray-600 mb-6">
                  Los cupos son limitados para asegurar instrucción de calidad
                </p>
                <button 
                  onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) {
                      const offset = 80;
                      const elementPosition = element.getBoundingClientRect().top;
                      const offsetPosition = elementPosition + window.pageYOffset - offset;
                      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                    }
                  }}
                  className="bg-[#D2691E] text-white px-10 py-4 rounded-full hover:bg-[#B8571A] transition-all shadow-lg font-semibold whitespace-nowrap"
                >
                  Reserva tu Lugar Ahora
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
